import store from "../../store";
import {
  onSavedSearchChangeAttachFromIci,
  setDocsForAttachToEmailAttachFromIci,
  setSelectedAgreementAttachFromIci,
  setSelectedAssociationAttachFromIci,
  setSelectedAttributesAttachFromIci,
  storeAgreementDataAttachFromIci,
  storeAssociationDataAttachFromIci,
  storeAssociationInstancesDataAttachFromIci,
  storeAttributeDataAttachFromIci,
  storeSavedSearchDataAttachFromIci,
} from "./redux/slice";

export const transformAttributeData = (data) => {
  let attributeData = [];
  for (let key in data) {
    if (key !== "$type") {
      let attrData = {};
      for (let value of data[key]) {
        if (value.Key === "AttributeId") {
          attrData = { ...attrData, attributeId: value.Value };
        }
        if (value.Key === "Name") {
          attrData = { ...attrData, name: value.Value };
        }
        if (value.Key === "ICMDisplayName") {
          attrData = { ...attrData, displayName: value.Value };
        }
        if (value.Key === "DataType") {
          attrData = { ...attrData, dataType: value.Value };
        }
        if (value.Key === "IsAttributeLocalized") {
          attrData = { ...attrData, isAttributeLocalised: value.Value };
        }
      }
      attributeData.push({
        id: key,
        ...attrData,
      });
    }
  }
  if (attributeData.length > 0) {
    attributeData = Array.from(
      new Map(attributeData.map((attribute) => [attribute["attributeId"], attribute])).values()
    ).sort((a, b) => a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase()));
  }
  return attributeData;
};

export const updateAttributeData = (data) => {
  store.dispatch(storeAttributeDataAttachFromIci(data));
};

export const setSelectedAttributeData = (data) => {
  store.dispatch(setSelectedAttributesAttachFromIci(data));
};

export const transformSavedSearchData = (data) => {
  let transformedSavedSearchData = [];
  const savedSearchData = data && data.ICMExecuteSavedSearchList ? JSON.parse(data.ICMExecuteSavedSearchList) : [];
  if (savedSearchData.length > 0) {
    transformedSavedSearchData = savedSearchData.map((data) => {
      return {
        id: data.id,
        label: data.name,
        value: data.name,
        entityName: data.entityName,
      };
    });
  }
  return transformedSavedSearchData;
};

export const updateSavedSearchData = (data) => {
  store.dispatch(storeSavedSearchDataAttachFromIci(data));
};

export const setSelectedSavedSearchData = (data) => {
  store.dispatch(onSavedSearchChangeAttachFromIci(data));
};

export const updateAgreementData = (data) => {
  store.dispatch(storeAgreementDataAttachFromIci(data));
};

export const setSelectedAgreementData = (data) => {
  store.dispatch(setSelectedAgreementAttachFromIci(data));
};

export const transformAssociationPartOneData = (data) => {
  const associationData = data.filter((association) => association.AssociationType !== 0);
  const ids = associationData.map((association) => association.AssociatedEntityId).join(",");
  return ids;
};

export const transformAssociationPartTwoData = ({ responsePartOne, responsePartTwo }) => {
  const associationsData =
    responsePartTwo && responsePartTwo.length > 0
      ? responsePartTwo.map((association) => {
          return {
            ...association,
            label: association.ICMDisplayName,
            value: association.ICMDisplayName,
            name: association.ICMDisplayName,
          };
        })
      : [];
  const filteredAssociationsData =
    associationsData && associationsData.length > 0
      ? associationsData.filter(
          (item) => !item.ICMDisplayName.toLowerCase().includes("amendment") && item.AllowDocumentUpload
        )
      : [];
  const transformedFilteredAssociationsData =
    filteredAssociationsData && filteredAssociationsData.length > 0
      ? filteredAssociationsData.map((ele) => {
          const filteredData = responsePartOne
            ? responsePartOne.filter((item) => item.AssociatedEntityId.toLowerCase() === ele.EntityInstanceId)
            : [];
          if (filteredData.length > 0) {
            return {
              ...ele,
              parentName: filteredData[0].AssociationName,
            };
          }
          return ele;
        })
      : [];
  return transformedFilteredAssociationsData;
};

export const updateAssociationData = (data) => {
  store.dispatch(storeAssociationDataAttachFromIci(data));
};

export const setSelectedAssociationData = (data) => {
  store.dispatch(setSelectedAssociationAttachFromIci(data));
};

export const updateAssociationInstanceData = (data) => {
  store.dispatch(storeAssociationInstancesDataAttachFromIci(data));
};

export const updateSetDocsForAttachToEmailData = (data) => {
  store.dispatch(setDocsForAttachToEmailAttachFromIci(data));
};
